/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { ComponentType, FunctionComponent } from 'react';
import { Loader } from '@scuf/common';
import './LoadingStatus.scss';
export interface ILoadingStatusProps {
  loading?: boolean;
  loadingText: string;
  silentLoading?: boolean;
  statusCode?: number | null;
  optimusSubscribed?: boolean;
}

const withLoadingStatus = <P extends Object>(
  WrappedComponent: ComponentType<P>
): FunctionComponent<P & ILoadingStatusProps> =>
  React.memo(
    ({
      loading,
      loadingText,
      silentLoading,
      ...props
    }: ILoadingStatusProps) => {
      return shouldDisplayLoader(loading, props.statusCode, silentLoading) ? (
        <div
          className={`${
            props.optimusSubscribed
              ? 'emaas-loader-container-optimus'
              : 'emaas-loader-container'
          }`}
        >
          <Loader loading={true} text={loadingText} />
        </div>
      ) : (
        <WrappedComponent {...(props as P)} />
      );
    }
  );

export default withLoadingStatus;
const shouldDisplayLoader = (
  loading?: boolean,
  statusCode?: number | null,
  silentLoading?: boolean
) => {
  if (silentLoading) return false;
  else if (loading || statusCode === 0 || statusCode === undefined) return true;
  //else if (loading === false && statusCode === undefined) return true;
  else return false;
};
